import React, { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Grid, 
  CircularProgress,
  Button,
  Alert
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { router } from '@inertiajs/react';

interface CustomerFeatureUsageProps {
  customer: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
  };
  usage: {
    [featureType: string]: number;
  };
  [key: string]: any; // Index signature for PageProps
}

export default function CustomerFeatureUsage() {
  const { props } = usePage<CustomerFeatureUsageProps>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleBack = () => {
    router.visit('/admin/tasks');
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: '1200px', margin: '0 auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          sx={{ mr: 2 }}
        >
          Back to Task Manager
        </Button>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Customer Feature Usage
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Customer Info Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {props.customer.first_name} {props.customer.last_name}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {props.customer.email}
          </Typography>
        </CardContent>
      </Card>

      {/* Feature Usage Stats */}
      <Typography variant="h6" sx={{ mb: 2 }}>
        Feature Usage Statistics
      </Typography>
      
      {Object.keys(props.usage).length === 0 ? (
        <Card>
          <CardContent>
            <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
              No feature usage recorded for this customer yet.
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={2}>
          {Object.entries(props.usage).map(([feature, count]) => (
            <Grid item xs={12} sm={6} md={4} key={feature}>
              <Card>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {count}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
} 